import React from 'react';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import LanguageContext from './languageContext';

function changeLanguageButton() {
  // The Theme Toggler Button receives not only the theme
  // but also a toggleTheme function from the context
  return (
    <LanguageContext.Consumer>
      {({ language, changeLanguage }) => (
        <div className="changeLanguage">
          <span>LN</span>
          <FormControl className="formControl inputHead coloredForms">
            <Select
              name="language-change"
              className="tableDropdown"
              disableUnderline
              onChange={ev => changeLanguage(ev.target.value)}
              value={language === 'eng' ? 'eng' : 'hindi'}
            >
              <MenuItem value="" disabled>
                Select Language
              </MenuItem>
              <MenuItem value="eng">English</MenuItem>
              <MenuItem value="hindi">Hindi</MenuItem>
            </Select>
          </FormControl>
          {/* <ul className="greenBtnHeader languageMain">
                      <Button
                        variant="contained"
                        color="primary"
                        className="button greenBtn"
                        onClick={changeLanguage}
                      >
                        {language === 'eng' ? 'Switch To Hindi' : 'Switch To English'}
                      </Button>
                    </ul> */}
        </div>
      )}
    </LanguageContext.Consumer>
  );
}

export default changeLanguageButton;
